import { useEffect, useState } from 'react'
import { meetingsApi } from '../services/meetings.api'

/**
 * The meeting password, for its host, from the server.
 *
 * The server keeps an encrypted copy beside the hash and returns it on
 * `GET /meetings/:id` to the host only. The screens used to read the password
 * from this browser's local store alone, which meetings scheduled through the
 * server never wrote to — so Edit Meeting showed an empty field even when a
 * random password had been generated at creation.
 *
 * Undefined while loading, for a non-host, with the password off, or when the
 * server has no recoverable copy (meetings saved before it kept one).
 */
export function useHostMeetingPassword(meetingId: string | undefined, enabled: boolean): string | undefined {
  const [password, setPassword] = useState<string | undefined>(undefined)
  useEffect(() => {
    setPassword(undefined)
    if (!enabled || !meetingId) return
    let cancelled = false
    meetingsApi
      .getById(meetingId)
      .then(({ meeting }) => {
        if (!cancelled && typeof meeting?.password === 'string' && meeting.password) setPassword(meeting.password)
      })
      .catch(() => { /* keep "password is set" */ })
    return () => { cancelled = true }
  }, [meetingId, enabled])
  return password
}
